import { FC } from 'react'

import { CheckCircle } from '@mui/icons-material'

export const CheckedStatusCircle: FC<{ value?: boolean }> = ({ value }) => {
  return value ? <CheckCircle color="success" /> : null
}
